//usage
// data-track-click
// data-module="RitchText"
// data-name="{{ $module->link_label }}"
// data-trackable-type="PageModule"
// data-trackable-id="{{ $module->id }}"

function getMeta(name) {
    const m = document.querySelector(`meta[name="${name}"]`);
    return m ? m.getAttribute('content') : null;
}

function getCsrf() {
    // Prefer meta tag (standard in Laravel layouts)
    const meta = getMeta('csrf-token');
    if (meta) return meta;

    // Fallback to XSRF-TOKEN cookie (Laravel sets it if you use axios/mix etc.)
    const m = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
}

function getEndpoint(opts) {
    return (opts && opts.endpoint) || getMeta('click-endpoint') || '/click-events';
}

function payloadFrom(el) {
    let meta = el.getAttribute('data-meta');
    try {
        meta = meta ? JSON.parse(meta) : null;
    } catch (e) {
        meta = { raw: el.getAttribute('data-meta') };
    }

    return {
        module: el.getAttribute('data-module') || 'unknown',
        name: el.getAttribute('data-name') || (el.textContent || '').trim() || null,
        button_id: el.getAttribute('id') || el.getAttribute('data-button-id') || null,
        trackable_type: el.getAttribute('data-trackable-type') || null,
        trackable_id: el.getAttribute('data-trackable-id') || null,
        url: window.location.href,
        referrer: document.referrer || null,
        meta: meta
    };
    
}

function send(endpoint, data, csrf) {
    // Non-blocking, does not prevent navigation or AJAX handlers
    if (navigator.sendBeacon) {
        const fd = new FormData();
        if (csrf) fd.append('_token', csrf);
        Object.keys(data).forEach((k) => {
            let v = data[k];
            if (typeof v === 'object' && v !== null) v = JSON.stringify(v);
            if (v !== undefined && v !== null) fd.append(k, v);
        });
        try { navigator.sendBeacon(endpoint, fd); } catch (_) {}
        return;
    }

    // Fallback: fire-and-forget fetch (won't block the click)
    try {
        fetch(endpoint, {
            method: 'POST',
            headers: {
            'X-Requested-With': 'XMLHttpRequest',
            ...(csrf ? { 'X-CSRF-TOKEN': csrf } : {}),
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            credentials: 'same-origin',
            keepalive: true
        }).catch(() => {});
    } catch (_) {}
}

function findTrackable(start) {
    let el = start;

    while (el && el !== document.body) {
        if (el.hasAttribute('data-track-click')) return el;
        el = el.parentElement;
    }
    return null;
}

export function initClickTracker(options = {}) {
    const endpoint = getEndpoint(options);
    const csrf = getCsrf();

    // One listener for the whole document; capture & passive so we do not affect behavior
    const handler = (ev) => {
        const target = findTrackable(ev.target);
        if (!target) return;

        // Build payload
        const data = payloadFrom(target);

        // Optional hook to enrich data programmatically
        if (typeof options.transform === 'function') {
            try { Object.assign(data, options.transform(data, target) || {}); } catch (_) {}
        }

        // Ship it without blocking the click
        send(endpoint, data, csrf);
    };

    // capture:true means we see the click early, passive:true guarantees we won't call preventDefault
    document.addEventListener('click', handler, { capture: true, passive: true });

    // Return an API in case you want to remove or manual-track later
    return {
        destroy() { document.removeEventListener('click', handler, { capture: true }); },
        track(dataOrEl, overrides = {}) {
            let data;
            
            if (dataOrEl instanceof Element) {
                data = payloadFrom(dataOrEl);
            } else {
                data = { ...dataOrEl };
            }

            Object.assign(data, overrides);

            send(endpoint, data, csrf);
        }
    };
}


// WEBPACK FOOTER //
// ./resources/assets/js/core/click-tracker.js